module.exports = __webpack_public_path__ + "images/b2edd96877c082561a3d1965b20e8f09-beverly hills.jpg";